// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5gmqm","rootMobile":"styles_rootMobile__1sAd6"};